<template>
  <SACModal
    modalClass="order-action-modal"
    :cardClass="`order-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'new-order'"
      #content
    >
      <NewCustomerOrder />
    </template>
    <template
      v-else-if="actionModalView === 'edit-shipping'
        || actionModalView === 'edit-billing'"
      #content
    >
      <EditAddress />
    </template>
  </SACModal>
</template>

<script>
import orderMixin from '@shared/mixins/orderMixin';
import SACModal from '@shared/components/sac/SACModal.vue';
import NewCustomerOrder from '@shared/components/customerDetail/modal/NewCustomerOrder.vue';
import EditAddress from './EditAddress.vue';

export default {
  name: 'Modal',
  components: {
    NewCustomerOrder,
    SACModal,
    EditAddress,
  },
  mixins: [orderMixin],
};
</script>

<style lang="scss">
;

.order-action-modal {
  .order-new-order {
    width: 700px;
    height: 700px;
    max-height: calc(100vh - 70px);

    .ac-body-container {
      overflow-y: auto;
    }
  }

  .order-edit-shipping,
  .order-edit-billing {
    width: 700px;
    height: 460px;
    max-height: calc(100vh - 70px);

    .ac-body-container {
      overflow-y: auto;
    }
  }

  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;

    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;

      .ac-header {
        font-size: 1.25rem;
        font-weight: 500;
      }

      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: $NBLUE20;
        }

        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }

    .ac-body-container {
      flex: 1;
      padding: 20px;

      .ac-checkbox-container {
        margin-bottom: 18px;
      }
      .order-btn {
        background-color: $N5;
        color: $BLACK;
        height: 30px;
        padding: 0 8px;
        border-radius: 6px;
        &.active {
          background-color: $NBLUE110;
          color: $WHITE;
        }
      }
      .ac-body-sub-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
        margin-bottom: 10px;

        .ac-input-container {
          &:not(:last-child) {
            margin-bottom: 18px;
          }

          .ac-input-header {
            font-size: 0.875rem;
            font-weight: 500;
            margin-bottom: 5px;

            .required {
              color: $TOMATO100;
            }
          }
        }
      }

      .ac-body-order-detail {
        display: grid;
        gap: 1rem;

        .od-top-container {
          .od-header {
            background: $SUNSET70;
            padding: 10px;
            font-weight: 700;
            text-transform: uppercase;
            border-radius: 6px;
            color: $N90;
          }

          .od-info {
            padding: 10px;
            display: grid;

            .od-info-item {
              font-size: 14px;
              color: $N90;
              display: grid;
              gap: 10px;
              margin-top: 10px;
            }

            .od-info-customer {
              font-size: 14px;
              color: $N100;
              font-weight: 500;
              border-bottom: 1px solid $N10;

              .od-info-sub-customer {
                display: grid;
                grid-auto-flow: column;
                justify-content: space-between;

                .od-f-icon {
                  padding: 0 9px;
                  background: $N100;
                  border-radius: 50%;
                  font-weight: 700;
                  font-size: 15px;
                  color: $WHITE;
                  margin-left: 10px;
                  cursor: pointer;
                  position: relative;

                  &:hover {
                    .od-filters-info {
                      display: block;
                    }
                  }

                  .od-filters-info {
                    display: none;
                    position: absolute;
                    background-color: $NBLUE10;
                    padding: 7px 16px 7px 16px;
                    box-shadow: 0 3px 6px rgba(9, 15, 32, 0.07);
                    border-radius: 6px;
                    white-space: nowrap;
                    right: 0;
                    color: $BLACK;

                    &:after {
                      content: '';
                      position: absolute;
                      top: 0;
                      right: 3px;
                      width: 0;
                      border: 8px solid transparent;
                      border-bottom-color: $NBLUE10;
                      border-top: 0;
                      margin-top: -8px;
                    }

                    .od-filter-label {
                      width: 100%;
                      font-size: 0.875rem;
                      color: $BLACK;
                      font-weight: 400;
                      border-top: 1px solid $N20;
                    }
                  }
                }
              }
            }
          }
        }

        .od-total-container {
          background: $N5;
          font-size: 13px;
          padding: 8px 10px;
          font-weight: 700;
          text-transform: uppercase;
          border-radius: 6px;
          color: $N90;
          display: grid;
          grid-auto-flow: column;
          justify-content: space-between;
        }
      }

      .ac-shipment-detail {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .ac-address-container {
          flex: 1;

          &:last-child {
            margin-left: 12px;
          }
        }

        .ac-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: $N5;
          border-radius: 6px;
          color: $N90;
          padding: 8px 10px;

          .ac-edit-btn {
            background-color: $N50;
            padding: 0 8px;
            color: $WHITE;
            font-size: 0.75rem;
            border-radius: 4px;
          }
        }

        .ac-body {
          padding: 4px 10px;
        }
      }
    }
  }

  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;

    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;

      &:hover {
        background-color: $NBLUE90;
      }

      &:not(:last-child) {
        margin-left: 11px;
        background-color: $NBLUE10;

        &:hover {
          background-color: $NBLUE20;
        }
      }
    }

    .ac-form-cancel-button {
      padding: 0 16px;
      height: 34px;
      border-radius: 6px;
      background-color: $TOMATO100;
      color: $WHITE;
      font-weight: 600;

      &:hover {
        background-color: $TOMATO200;
      }
    }
  }

  .ac-overlay {
    border-radius: 12px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
